import { FormattedMessage, useIntl } from "react-intl";
import { addSeconds, formatDistance } from "date-fns";
import { Fragment } from "react";
import { Stack as MuiStack } from "@mui/material";

import { formatItem, formatPenalty } from "@framework/exchange";
import { DurationUnit, IAsset } from "@framework/types";
import { SwitchInput } from "@dzambalaorg/mui-inputs-core";
import { Typography } from "@dzambalaorg/ui-kit";

import { normalizeDuration } from "../../../utils/time";

export interface IDepositRule {
  deposit?: IAsset;
  reward?: IAsset;
  durationAmount: number;
  durationUnit: DurationUnit;
  penalty: number;
  recurrent?: boolean;
}

export interface IDepositRewardDto {
  rule: IDepositRule;
  startTimeStamp: string;
  withdrawDeposit: boolean;
  breakLastPeriod?: boolean;
}

export interface IRewardDialogProps {
  initialValues: IDepositRewardDto;
}

export const DepositRewardDialog = (props: IRewardDialogProps) => {
  const { initialValues } = props;
  const { rule, startTimeStamp } = initialValues;

  const { formatMessage } = useIntl();

  return (
    <Fragment>
      <Typography variant="h6" color="textSecondary" mt={theme => theme.tokens.spacing.xl}>
        <FormattedMessage
          id="dialogs.reward-item"
          values={{
            item: formatItem(rule.reward),
            period: `${formatMessage(
              { id: `enums.durationUnit.${rule.durationUnit}` },
              {
                count: normalizeDuration({
                  durationAmount: rule.durationAmount,
                  durationUnit: rule.durationUnit,
                }),
              },
            )}`,
          }}
        />
      </Typography>
      <MuiStack mt={theme => theme.tokens.spacing.xl} mb={theme => theme.tokens.spacing.xl}>
        <Typography variant="body1" color="textSecondary" component="div">
          <FormattedMessage
            id="dialogs.penalty"
            values={{
              item: formatPenalty(rule.penalty),
              description: "",
            }}
          />
        </Typography>
        <Typography variant="body1" color="textSecondary" component="div">
          <FormattedMessage
            id="dialogs.staking-duration"
            values={{
              duration: formatDistance(addSeconds(new Date(startTimeStamp), rule.durationAmount || 0), Date.now(), {
                addSuffix: true,
              }),
            }}
          />
        </Typography>
      </MuiStack>
      <MuiStack gap={theme => theme.tokens.spacing.sm}>
        <SwitchInput name="withdrawDeposit" />
        {rule.recurrent && <SwitchInput name="breakLastPeriod" />}
      </MuiStack>
    </Fragment>
  );
};
